import { isValid } from 'date-fns';
import { useState } from 'react';

interface UseCatalogCreationAccessDateCellParams {
  onChange: (date: Date | null) => void;
}

export const useCatalogCreationAccessDateCell = ({
  onChange,
}: UseCatalogCreationAccessDateCellParams) => {
  const [hasInvalidDate, setHasInvalidDate] = useState(false);

  const handleChangeDate = (date: Date | null) => {
    setHasInvalidDate(!!date && !isValid(date));
    onChange(date);
  };

  return { hasInvalidDate, handleChangeDate };
};
